import { t } from 'i18next';
import { useDispatch } from 'react-redux';

import { useAppSelector } from '@/app/hooks';
import { ChuteSchedulerActions } from '@/app/slices/chuteScheduler';
import { Input } from '@/components/ui/input';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip';

type Props = {
  className?: string;
};

export const Interval = ({ className }: Props) => {
  const dispatch = useDispatch();
  const { interval } = useAppSelector((state) => state.chuteScheduler);

  const handleChange = (val: number | null) => {
    dispatch({
      type: ChuteSchedulerActions.UPDATE_INTERVAL,
      interval: val ?? 0,
    });
  };

  return (
    <div
      className={`${className ? `${className} ` : ''}label-input-group flex flex-col gap-1`}
    >
      <Tooltip>
        <TooltipTrigger
          render={
            <label className="w-fit cursor-help text-sm">
              {t('chuteScheduler.interval')}
            </label>
          }
        />
        <TooltipContent>Minutes between scheduled aspirations.</TooltipContent>
      </Tooltip>

      <Input
        type="number"
        className="w-full md:w-20"
        value={interval ?? ''}
        onChange={(e) =>
          handleChange(e.target.value === '' ? null : Number(e.target.value))
        }
        min={0}
        max={60}
        aria-invalid={interval == null || interval < 0 || interval > 60}
      />
    </div>
  );
};
